module.exports = __webpack_public_path__ + "img/btn_menu_ymbz_c.9e88c240.png";